module.exports = __webpack_public_path__ + "static/img/HeNan_jianjiePic.104dd4a4.png";